'use client'

import { Anchor, Button, Group, Paper, Text } from '@mantine/core'
import NextLink from 'next/link'
import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'

import { ROUTE_COOKIE_POLICY } from '@/lib/routes'

const COOKIE_KEY = 'cookie_consent'
const CONSENT_CHANGED_EVENT = 'consentChanged'
type Consent = 'accepted' | 'rejected' | null

export const CookieConsentBanner: React.FC = () => {
  const t = useTranslations('cookie_consent')
  const [consent, setConsent] = useState<Consent>(null)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
    const stored = window.localStorage.getItem(COOKIE_KEY)
    if (stored === 'accepted' || stored === 'rejected') setConsent(stored)
  }, [])

  const handleAccept = () => {
    window.localStorage.setItem(COOKIE_KEY, 'accepted')
    setConsent('accepted')
    window.dispatchEvent(new Event(CONSENT_CHANGED_EVENT))
  }

  const handleReject = () => {
    window.localStorage.setItem(COOKIE_KEY, 'rejected')
    setConsent('rejected')
    window.dispatchEvent(new Event(CONSENT_CHANGED_EVENT))
  }

  if (!isClient || consent) return null

  return (
    <Paper
      shadow="md"
      p="md"
      radius="md"
      withBorder
      style={{ position: 'fixed', bottom: 16, left: 16, right: 16, zIndex: 1000 }}
    >
      <Text>
        {t('message')}{' '}
        <Anchor component={NextLink} href={ROUTE_COOKIE_POLICY}>
          {t('learn_more')}
        </Anchor>
      </Text>
      <Group mt="sm">
        <Button onClick={handleAccept}>{t('accept')}</Button>
        <Button variant="outline" onClick={handleReject}>
          {t('reject')}
        </Button>
      </Group>
    </Paper>
  )
}
